
<template>
    <div class='card rating'>
        <div class='card-content'>
            <div class="media">
                <div class="media-left">
                    <h1 class="is-size-4"
                        :class="colorClass">
                        <span>{{rating.score}}</span>
                        <b-icon icon="star" size="is-small"/>
                    </h1>
                </div>

                <div class="media-content">
                    <p class="title is-4">{{rating.title}}</p>

                    <p class="subtitle is-6">
                        {{rating.name}}
                        <template v-if="rating.position">
                            - <span class="is-italic">{{rating.position}}</span>
                        </template>
                    </p>
                </div>

                <div v-if="isEmployee && !preview" class="is-pulled-right">
                    <b-dropdown aria-role="list">
                        <button class="button" slot="trigger">
                            <b-icon icon="dots-vertical" />
                        </button>

                        <b-dropdown-item aria-role="listitem">{{$t('global.actions.edit')}}</b-dropdown-item>
                        <b-dropdown-item aria-role="listitem" @click="showDeleteModal = true">{{$t('global.actions.delete')}}</b-dropdown-item>
                    </b-dropdown>

                    <delete-rating-modal v-if="showDeleteModal"
                                         :student="student" :rating="rating"
                                         @deleted="reloadRatings()"
                                         @close="showDeleteModal = false"/>
                </div>
            </div>

            <div class="content">
                <p class="is-italic" v-html="body" />
            </div>

            <br>

            <a href="#" @click.prevent="showMore = !showMore" v-if="rating.body.length >= 180" class="is-italic">
                {{!showMore ? 'Vis mere' : 'Vis mindre'}}
                <b-icon :icon="!showMore ? 'chevron-down' : 'chevron-up'" size="is-small" />
            </a>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .rating {
        border-bottom: 1px solid rgba(10, 10, 10, 0.1);
        box-shadow: none;

        &:last-child {
            border-bottom: none;
        }

        .card-content {
            padding: 1rem;
        }
    }
</style>

<script>
    import AccountMixin from '@/global/mixins/AccountMixin';
    import DeleteRatingModal from '@/taskflex/students/components/profile/ratings/DeleteRatingModal';
    import { mapGetters } from 'vuex';
    import Stars from '@/taskflex/students/components/profile/ratings/Stars';

    export default {
        data() {
            return {
                showMore: false,
                showDeleteModal: false,
                showEditModal: false,
            };
        },

        props: {
            rating: {
                type: Object,
                required: true,
            },

            student: {
                type: Object,
                required: true,
            },

            preview: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        computed: {
            ...mapGetters('auth', [
                'isEmployee',
            ]),

            body() {
                const { rating, showMore } = this;

                if (rating.body.length < 180 || showMore === true) {
                    return rating.body;
                }

                return `${rating.body.substr(0, 180)} ...`;
            },

            colorClass() {
                const { rating } = this;

                if (rating.score >= 4) {
                    return 'has-text-primary';
                }

                if (rating.score >= 2) {
                    return 'has-text-orange';
                }

                return 'has-text-danger';
            },
        },

        mixins: [AccountMixin],

        methods: {
            reloadRatings() {
                this.$eventHub.$emit('student.detail.reload');
                this.$eventHub.$emit('students.profile.update'); // TODO: change?
            },
        },

        components: {
            DeleteRatingModal,
            Stars,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/students/components/profile/ratings/Rating.vue